module.exports = __webpack_public_path__ + "5aa4edf3e7c890f645c75b7266a2b3f0.png";